import Icon from '@/components/ui/AppIcon';

interface MissionValuesProps {
  className?: string;
}

const solutions = [
  {
    title: 'Cash Offer',
    icon: 'CurrencyDollarIcon',
    description:
      'Sell as-is, close in 30 days or less. No repairs, no showings, no agent commissions. When speed matters more than anything else, this is the path.',
  },
  {
    title: 'Loan Assumption',
    icon: 'ArrowsRightLeftIcon',
    description:
      'We take over your existing mortgage terms. If your rate is below current market, this often means a faster sale and more money in your pocket — without waiting for a traditional buyer to qualify.',
  },
  {
    title: 'Creative Financing',
    icon: 'SparklesIcon',
    description:
      "Non-traditional deal structures that solve problems a cash offer can't — whether that's a timing issue, an equity preservation concern, or a situation that doesn't fit conventional lending.",
  },
  {
    title: 'Investor Pairing',
    icon: 'UserGroupIcon',
    description:
      'We connect your property directly with qualified buyers who specialize in your type of deal. No retail buyers who back out at inspection. Buyers who know what they’re buying.',
  },
  {
    title: 'Tenant-Occupied Solutions',
    icon: 'KeyIcon',
    description:
      "Don't evict before you sell. We work with buyers who purchase with tenants already in place — protecting your cash flow and avoiding a drawn-out eviction process.",
  },
  {
    title: 'Traditional MLS Listing',
    icon: 'HomeIcon',
    description:
      "When the market timing is right and you're not under pressure, listing gets you maximum exposure and typically maximum price. We'll tell you honestly when this is the better choice — even when it's not the fastest one for us.",
  },
];

const MissionValues = ({ className = '' }: MissionValuesProps) => {
  return (
    <section className={`bg-background py-16 lg:py-24 ${className}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-14 max-w-4xl">
          <div className="mb-12 h-px w-20 bg-accent"></div>
          <h2 className="font-heading text-[46px] font-normal leading-[1] text-foreground md:text-[62px]">
            One conversation. Multiple paths <span className="italic text-plum">forward.</span>
          </h2>
          <p className="mt-6 max-w-[720px] font-heading text-[22px] leading-[1.55] text-muted-foreground">
            We don&apos;t offer you what&apos;s easiest for us. We offer what fits your situation.
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {solutions.map((solution) => (
            <article
              key={solution.title}
              className="border border-border bg-card/70 p-7 shadow-card transition-shadow hover:shadow-luxury"
            >
              <div className="mb-6 flex h-11 w-11 items-center justify-center border border-plum/20 bg-plum-tint text-plum">
                <Icon name={solution.icon} size={22} />
              </div>
              <h3 className="mb-4 font-heading text-3xl font-normal text-foreground">
                {solution.title}
              </h3>
              <p className="leading-relaxed text-muted-foreground">{solution.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionValues;
